var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 0C6.93848 0 3.82324 2.38281 0 6.25C3.29102 9.55566 6.05469 12.5 10.9375 12.5C15.8154 12.5 19.4043 8.76953 21.875 6.31836C19.3457 3.44727 15.7617 0 10.9375 0ZM10.9375 10.708C8.52539 10.708 6.5625 8.70605 6.5625 6.25C6.5625 3.78906 8.52539 1.79199 10.9375 1.79199C13.3496 1.79199 15.3125 3.79395 15.3125 6.25C15.3125 8.71094 13.3496 10.708 10.9375 10.708Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 4.6875C10.9375 4.30176 11.0791 3.9502 11.3086 3.67676C11.1865 3.65723 11.0645 3.64746 10.9375 3.64746C9.53125 3.64746 8.38379 4.81445 8.38379 6.25C8.38379 7.68555 9.53125 8.85254 10.9375 8.85254C12.3438 8.85254 13.4912 7.68555 13.4912 6.25C13.4912 6.1377 13.4814 6.02539 13.4717 5.91309C13.2031 6.12305 12.8711 6.25 12.5049 6.25C11.6357 6.25 10.9375 5.55176 10.9375 4.6875Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5469a128360148401ebe7e93a8c78b69.svg";
export { ForwardRef as ReactComponent };